module.exports = new __parcel__URL__("elf-title-talent-10.19f4f6c6.gif").toString();